import { EngagementAction } from "@models/engagementAction";

export class EngagementActionSerializer {
  deserialize(data: any): EngagementAction {
    return new EngagementAction({
      id: data?.id,
      type: data?.type,
      sequence: data?.sequence,
      assigned_roles: data?.assigned_roles ?? [],
      is_active: data?.is_active,
      completed_at: data?.completed_at ?? null,
      completed_by_id: data?.completed_by_id ?? null,
      todo_id: data?.todo_id,
      engagement_id: data?.engagement_id,
      engagement_name: data?.engagement_name,
      launch_ad_id: data?.launch_ad_id,
      launch_name: data?.launch_name,
      ad_name: data?.ad_name,
    });
  }

  deserializeList(list: any[]): EngagementAction[] {
    return (list ?? []).map((entry) => this.deserialize(entry));
  }
}
